/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Avatar, Grid, Typography } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { GridColumns } from '@mui/x-data-grid-pro';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Accordion from 'components/Common/Accordion/Accordion';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import { AlertTitleTh, AxiosGet, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';
import RadioFormItem from 'components/Common/ElementInForm/RadioFormItem';
import AsyncAutoComplete from 'components/Common/ElementInForm/AsyncAutoComplete';
import { BtnBack, BtnConfirm, BtnReject, BtnSave } from 'components/Common/Button';
import moment from 'moment';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import UserAvatar from "../../../assets/Image/user-avatar.png";
import {
    DataGridMui as Table,
    initRows,
    PaginationInterface,
} from "components/Common/Table/DataGridMui";
import ModalRejectUser from './ModalRejectUser';


const OptionStatus = [
    { value: "1", label: "ใช้งาน" },
    { value: "0", label: "ไม่ใช้งาน" },
]

const ActivateForm = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const [oDataUser, setDataUser] = useState({})
    const [sUserID, setUserID] = useState(null)

    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    const [IsOpenReject, setIsOpenReject] = useState(false)

    const [loadingTable, setLoadingTable] = useState(true);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dAction",
        sSortDirection: "desc"
    });

    //#region  Form
    let objSchema = {
        sTitle: yupFormSchemas.string("คำนำหน้า", { required: true }),
        sName: yupFormSchemas.string("ชื่อ", { required: true }),
        sLname: yupFormSchemas.string("นามสกุล", { required: true }),
        arrCompany: yupFormSchemas.string("บริษัท", { required: true }),
        arrAddress: yupFormSchemas.string("สถานที่", { required: true }),
        oTel: yupFormSchemas.string("หมายเลขโทรศัพท์", { required: true }),
        eEmail: yupFormSchemas.string("อีเมล", { required: true }),
        sUnit: yupFormSchemas.string("หน่วยงาน", { required: false }),
        IsActive: yupFormSchemas.string("สถานะ", { required: true }),
        oOwnerPTT: yupFormSchemas.object("พนักงาน ปตท. ที่ดูแล", { required: true }),
    }

    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion

    useEffect(() => {
        BlockUI()

        const queryString = location.search;
        const urlParams = new URLSearchParams(queryString);
        const sID = urlParams.get("sActivate");

        if (sID != null) {
            onGetUser(sID)
            setUserID(sID)
        } else {
            SwAlert.Error(AlertTitleTh.Error, "ไม่พบข้อมูลสำหรับ Activate ลูกค้า", () => {
                navigate("/Backend/Admin/Activate")
            })
        }

        setTimeout(() => {
            UnBlockUI()
        }, 3000);
    }, [])

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: "ที่",
            headerAlign: "center",
            width: 50,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "dAction",
            headerName: "วันที่ดำเนินการ",
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;

                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
        {
            field: "sStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: false
        },
        {
            field: "sRemark",
            headerName: "หมายเหตุ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: false
        }
    ];

    const onGetUser = async (sUserID) => {
        await AxiosGet(`User/GetUserByID`, { sUserID: sUserID }, (res) => {
            ResultAPI(res, null, () => {

                if (res.statusCode === 200) {
                    let data = res.result.data;

                    if (data == null) {
                        navigate("/Backend/Admin/Activate")
                    }
                    UnBlockUI()
                    setDataUser(data)

                    //set form
                    form.setValue("sName", data.sFName)
                    form.setValue("sLname", data.sLName)
                    form.setValue("sTitle", data.sTitleTH)
                    form.setValue("arrCompany", data.sDefault_CompanyTH)
                    form.setValue("arrAddress", data.sDefault_Addr)
                    form.setValue("oTel", data.sDefault_Tel)
                    form.setValue("eEmail", data.sEmail)
                    // if (data.cSaleRepType == "E") {
                    //     form.setValue("sUnit", data.sSaleRepCode + " : " + data.sSaleRepBA)
                    // }
                    if (data.oPTTOwner?.value != null) {
                        form.setValue("oOwnerPTT", data.oPTTOwner)
                    }
                    let sSale = data?.sSaleRepCode + " : " + data?.sSaleRepName


                    form.setValue("sUnit", sSale)

                    form.setValue("IsActive", "1")


                    if (res.result.lstLogRegister) {
                        setDataRow({
                            ...dataRow,
                            arrRows: res.result.lstLogRegister || [],
                            nDataLength: res.result.lstLogRegister.length,
                            nPageIndex: 0,
                        });
                    }
                } else {
                    SwAlert.Error(AlertTitleTh.Error, res.Message, () => {
                        navigate("/Backend/Admin/Activate")
                    })
                }

            })
        }, (err) => {
            if (err?.response?.data?.Message) {
                // BlockUI()
                SwAlert.Error(AlertTitleTh.Error, err.response.data.Message, () => {
                    UnBlockUI()
                    navigate("/Backend/Admin/Activate")
                })
            }
        });
    }

    const onActivated = () => {

        let data = {
            IsActive: form.getValues("IsActive") === "1" ? true : false,
            sUserID: sUserID,
            sSaleRepCode: form.getValues("oOwnerPTT") != null ? form.getValues("oOwnerPTT").value : null,
        }

        let sMessage = "คุณต้องการที่จะ Activate User นี้ใช่หรือไม่ ?"

        SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
            BlockUI();
            AxiosPost(`User/ActivatedUser`, data, (res) => {
                ResultAPI(res, null, () => {
                    if (res.statusCode === 200 && res.Message === null) {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar("บันทึกข้อมูลสำเร็จ")
                        setsSeveritySnackbar("success")
                        setTimeout(() => {
                            UnBlockUI();
                            navigate("/Backend/Admin/Activate")
                        }, 2000)
                    } else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")
                        UnBlockUI();
                    }
                })
            });
        })
    }


    return (
        <>
            <InnerHeadRoutes
                iconMUI={<ManageAccountsIcon style={{ fontSize: '1.5em' }} />}
                labal_Head="Activate User"
            />
            <FormProvider {...form}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{ marginTop: '0' }}>
                    <Grid item container xs={12} spacing={2}>
                        <Grid item xs={12} sm={8}>
                            <Accordion header={"ข้อมูลลูกค้า"}>
                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                    <Grid item xs={12} sm={4} md={2}>
                                        <InputFormItem
                                            id="sTitle"
                                            name="sTitle"
                                            label="คำนำหน้า"
                                            required={true}
                                            disabled={true}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={5}>
                                        <InputFormItem
                                            id="sName"
                                            name="sName"
                                            label="ชื่อ"
                                            required={true}
                                            disabled={true}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={5}>
                                        <InputFormItem
                                            id="sLname"
                                            name="sLname"
                                            label="นามสกุล"
                                            required={true}
                                            disabled={true}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} >
                                        <InputFormItem
                                            id="arrCompany"
                                            name="arrCompany"
                                            label="บริษัท"
                                            required={true}
                                            disabled={true}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} >
                                        <InputFormItem
                                            id="arrAddress"
                                            name="arrAddress"
                                            label="สถานที่"
                                            required={true}
                                            disabled={true}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputFormItem
                                            id="oTel"
                                            name="oTel"
                                            label="หมายเลขโทรศัพท์"
                                            required={true}
                                            disabled={true}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputFormItem
                                            id="eEmail"
                                            name="eEmail"
                                            label="อีเมล"
                                            required={true}
                                            disabled={true}
                                            fullWidth
                                        />
                                    </Grid>
                                    {oDataUser['cSaleRepType'] == "U" &&
                                        <Grid item xs={6}>
                                            <InputFormItem
                                                id="sUnit"
                                                name="sUnit"
                                                label="หน่วยงาน"
                                                required={true}
                                                disabled={true}
                                                fullWidth
                                            />
                                        </Grid>
                                    }
                                    <Grid item xs={oDataUser['cSaleRepType'] == "U" ? 6 : 12}>
                                        <AsyncAutoComplete
                                            name="oOwnerPTT"
                                            label="พนักงาน ปตท. ที่ดูแล"
                                            required={oDataUser['cSaleRepType'] != "E"}
                                            disabled={oDataUser['cSaleRepType'] == "E"}
                                            fullWidth
                                            sUrlAPI={"User/SearchEmpPISByCompany"}
                                            ParamUrl={{ "sSoldTo": oDataUser['sSoldTo'], "sShipTo": oDataUser['sShipTo'] }}

                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <RadioFormItem
                                            name="IsActive"
                                            label="สถานะ"
                                            required={true}
                                            options={OptionStatus}
                                            value={form.getValues("IsActive")}
                                            row={true}
                                            disable={true}
                                            IsNewLine={false}
                                        />
                                    </Grid>
                                </Grid>
                            </Accordion>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <div
                                style={{
                                    width: '100%',
                                    border: '1px solid #d5d5d5 !important',
                                    padding: '16px',
                                    borderRadius: '10px',
                                    backgroundColor: '#fff',
                                    height: '100%'
                                }}
                            >
                                <Grid container spacing={3} justifyContent="center" alignItems="center">
                                    <Grid item xs={12}>
                                        <Avatar src={UserAvatar ?? ""} style={{ width: '9em', height: '9em', margin: '0 auto' }} />
                                    </Grid>
                                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                                        <Typography>ชื่อผู้ใช้งาน: {oDataUser['sFName'] + " " + oDataUser['sLName']}</Typography>
                                        <Typography>วันที่ลงทะเบียน: {moment(oDataUser['dCreate']).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + ""}</Typography>
                                    </Grid>
                                    {oDataUser && oDataUser['IsRejectRegister'] != true && oDataUser['IsActivateByAdmin'] != true &&
                                        <>
                                            <Grid item xs={6}>
                                                <Grid container justifyContent="center" alignItems="center">
                                                    <Grid item>
                                                        <BtnSave txt="Activate" onClick={form.handleSubmit(() => { onActivated() })} />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Grid container justifyContent="center" alignItems="center">
                                                    <Grid item>
                                                        <BtnReject txt="Reject" onClick={() => { setIsOpenReject(true); }} />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Accordion header={"History Log"}>
                            <Table
                                Rows={dataRow}
                                HiddenToolHead={true}
                                Columns={dataColumn}
                                backgroundHeaderCustom={"#004290"}
                                sxCustomHeader={{ color: '#ffffff' }}
                                isNotShowPagination={true}
                            />
                        </Accordion>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1} justifyContent="center" alignItems="center">
                            <Grid item>
                                <BtnBack onClick={() => navigate("/Backend/Admin/Activate")} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </FormProvider>

            <ModalRejectUser
                IsOpen={IsOpenReject}
                setIsOpen={setIsOpenReject}
                sUserID={sUserID}
                sRedirect={"/Backend/Admin/Activate"}
                setIsOpenSnackbar={setIsOpenSnackbar}
                setsSeveritySnackbar={setsSeveritySnackbar}
                setsMessageSnackbar={setsMessageSnackbar}
            />
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />

        </>
    )
}

export default ActivateForm